module.exports = __webpack_public_path__ + "static/TOKENOMY-25443891a7bdf548881c4c53eaab0cb8.png";